<template>
    <div>
        <el-card class="search-form-card">

            <el-form :inline="true" :model="form" class="search-form">
                <el-form-item label="关键字搜索:">
                    <el-input v-model="form.keyword" placeholder="请输入关键字" class="common-input"></el-input>
                    <el-button type="primary" @click="requestQuery">搜索</el-button>
                </el-form-item>
            </el-form>

        </el-card>

        <el-card>

            <div slot="header">
                <router-link  :to="{ path:'/serveCelevelUpdata',query: { callback:request } }">
                    <el-button type="primary">新增</el-button>
                </router-link>
            </div>

            <el-table
                :data="tableData"
                row-key="id"
                border
                default-expand-all
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                v-loading='loading'>

                <el-table-column label="序号" width="70" align="center">
                    <template slot-scope="scope">
                        <span v-for='item of pageSizes' :key='item' v-if="form.pageSize===item">
                            {{form.pageIndex>1 ? scope.$index+1+(form.pageIndex-1)*item : scope.$index+1}}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column label="协议名称" prop="title"></el-table-column>

                <el-table-column label="协议说明" prop="description"></el-table-column>

                <el-table-column label="服务方" prop="server">
                    <template slot-scope='scope'>
                        {{scope.row.server.name}}
                    </template>
                </el-table-column>

                <el-table-column label="合同" >
                    <template slot-scope="scope">
                        {{scope.row.contract.title}}
                    </template>
                </el-table-column>

                <el-table-column label="更新日期" prop="updateTime"></el-table-column>

                <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <router-link :to="{ path: '/serveCelevelUpdata',
                                        query: { form:scope.row, type:'edit', callback:request }}">
                            <el-button type="text" >修改</el-button>
                        </router-link>

                        <router-link :to="{ path: '/serveCelevelDetail', query: { form:scope.row }}">
                            <el-button type="text" >详情</el-button>
                        </router-link>

                        <el-button v-w-role="'ITSM-0074'" class="table-del-btn" type="text" @click="deleteRole(scope.$index, tableData, scope.row.serialNumber)">删除</el-button>

                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页器 -->
            <el-pagination
             @size-change="handleSizeChange"
             @current-change="handleCurrentChange"
             :current-page="form.pageIndex"
             :page-sizes="pageSizes"
             :page-size="form.pageSize"
             layout="total, sizes, prev, pager, next, jumper"
             :total="total">
            </el-pagination>

        </el-card>

    </div>
</template>

<script>
import Pagination from '../../../components/Pagination'
import services from '../serve.services'


export default {

    components: { Pagination },

    data() {
        return {
            total: 10,
            loading: true,
            tableData: [],
            form: {
                keyword: '',
                pageIndex: 1,
                pageSize: 10,
            },
            pageSizes: [10, 20, 30, 40]

        }
    },

    mounted() {
        this.request()
    },

    methods: {
        requestQuery(){
            this.form.pageIndex = 1;
            this.request();
        },
        // 请求数据
        request() {

            this.tableData = []
            this.loading = true
            services.serviceSlaList(this.form)
                .then(res => {
                    this.tableData = res.list
                    this.total = +res.total
                })
                .catch(err => this.$message.error(err.message))
                .finally(() => this.loading = false)
        },

        // 删除数据
        deleteRole(index, rows,serialNumber) {
            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).then(() => {
                services.serviceSlaDelete({serialNumber})
                    .then(res => {
                        rows.splice(index, 1)
                        this.$message.success('删除成功！')
                    })
                    .catch(err => this.$message.error(err.message))
            })
            .catch(() => this.$message.info('已取消删除'))
        },

        // 更新分页器页数
        handleSizeChange(val){
            let pages = Math.ceil(this.total / val);
            this.form.pageSize = val;
            if(this.form.pageIndex > pages ){
                this.form.pageIndex  = 1;
            };
            this.request();
        },

        // 更新分页器页码
        handleCurrentChange(val){
            this.form.pageIndex = val;
            this.request();
        },
    }
}
</script>

<style lang="scss" scoped>

</style>
